import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/Shared/ProtectedRoute";
import RoleGuard from "./components/Shared/RoleGuard";
import DirectorySuccess from "./components/Shared/DirectorySuccess";
// General Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import NotFoundPage from "./pages/NotFoundPage";
// import ConnectedDirectory from "./components/Shared/ConnectedDirectoryModal";
// Viewer Pages
import DashboardHome from "./pages/DashboardHome";
import DashboardLayoutViewer from "./components/Viewer/DashboardLayout";
import CompanyList from "./components/Shared/CompanyList";
// Company Admin Pages
import CompanyProfilePage from "./pages/CompanyAdmin/CompanyProfilePage";
import DashboardLayoutCompany from "./components/CompanyAdmin/DashboardLayout";
// Super Admin Pages (add actual pages when needed)
import DashboardLayoutSuper from "./components/SuperAdmin/DashboardLayout";
// import FlaggedReviews from "./components/SuperAdmin/FlaggedReviews";
import FlaggedReviewsTable from "./components/SuperAdmin/FlaggedReviewsTable";
import AllListingRequestsTable from "./components/SuperAdmin/AllListingRequestsTable";
//Landing Page
import LandingPage from "./components/Shared/LandingPage";
import PrivacyPolicy from "./components/Shared/PrivacyPolicy";
import TermsAndConditions from "./components/Shared/TermsAndConditions";
import LandingPageNew from "./pages/LandingPageNew";
import HowRemoveStep2 from "./pages/HowRemoveStep2";
//Pages
import AboutUs from "./pages/AboutUs";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import Counselore from "./pages/Counselore";
import DeleteRating from "./pages/DeleteRating";
import LocalListing from "./pages/LocalListing";
import RequestQuote from "./pages/RequestQuote";
import WebDesign from "./pages/WebDesign";
import ScrollToTop from "./utils/ScrollToTop";
import CrmAutomation from "./pages/CrmAutomation";
import Impressum from "./pages/Impressum";
import DataProtection from "./pages/DataProtection";
import ScrollToTopButton from "./components/ScrollToTopButton";
import HowRemove1 from "./pages/HowRemove1";
import HowRemove2 from "./pages/HowRemove2";
import HowRemove3 from "./pages/HowRemove3";
import { HelmetProvider } from "react-helmet-async";
import BlogDetail from "./components/Blog/BlogDetail";
function App() {
  return (
    <>
     <HelmetProvider>
  <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            {/* 🔓 Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/ki-automatisierung-prozesse" element={<CrmAutomation />} />
            <Route path="/ueber-uns" element={<AboutUs />} />
            <Route path="/karriere" element={<Career />} />
            <Route path="/kontak" element={<Contact />} />
            <Route path="/ratgeber" element={<Counselore />} />
            <Route path="/bewertung-loeschen" element={<DeleteRating />} />
            <Route path="/local-listing-optimierung" element={<LocalListing />} />
            <Route path="/unverbindliches-angebot" element={<RequestQuote />} />
            <Route path="/webdesign-agentur-bremen" element={<WebDesign />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/vv" element={<LandingPage />} />
            <Route path="/" element={<LandingPageNew />} />
            <Route path="/Bewertungsmanager" element={<HowRemoveStep2 />} />
            <Route path="/Bewertungsmanager-1" element={<HowRemove1 />} />
            <Route path="/Bewertungsmanager-2" element={<HowRemove2 />} />
            <Route path="/Bewertungsmanager-3" element={<HowRemove3 />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutzerklaerung" element={<DataProtection />} />
           <Route path="/ratgeber/:slug" element={<BlogDetail />} />
            {/* <Route path="/" element={<RegisterPage />} /> */}
            {/* 🔒 Viewer Routes */}
            <Route
              path="/viewer"
              element={
                <ProtectedRoute>
                  <RoleGuard role="viewer">
                    <DashboardLayoutViewer />
                  </RoleGuard>
                </ProtectedRoute>
              }
            >
              <Route path="companies-list" element={<CompanyList />} />

              {/* Add more viewer routes here if needed */}
            </Route>

            {/* 🔒 Company Admin Routes */}
            <Route
              path="/company"
              element={
                <ProtectedRoute>
                  <RoleGuard role="admin">
                    <DashboardLayoutCompany />
                  </RoleGuard>
                </ProtectedRoute>
              }
            >
              <Route path="your-company" element={<CompanyProfilePage />} />
              <Route path="companies-list" element={<CompanyList />} />
              <Route path="create-company" element={<CompanyProfilePage />} />

              <Route path="directory-success" element={<DirectorySuccess />} />
              <Route path="edit-company/:id" element={<CompanyProfilePage />} />
              {/* Add more company admin routes here */}
            </Route>

            {/* 🔒 Super Admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <RoleGuard role="super_admin">
                    <DashboardLayoutSuper />
                  </RoleGuard>
                </ProtectedRoute>
              }
            >
              <Route path="companies-list" element={<CompanyList />} />
              <Route path="create-company" element={<CompanyProfilePage />} />
              <Route path="edit-company/:id" element={<CompanyProfilePage />} />

              <Route path="flagged-reviews" element={<FlaggedReviewsTable />} />
              <Route
                path="requested-listings"
                element={<AllListingRequestsTable />}
              />

              {/* Add super admin routes here */}
            </Route>

            {/* 🔁 Catch-All */}

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AuthProvider>
        <ScrollToTopButton />
      </BrowserRouter>

     </HelmetProvider>
    
    </>
  );
}

export default App;
